// PRODUCTS
const PERMISSIONS_obj = [
        'PRODUCT_VIEW',
        'PRODUCT_ADD',
        'PRODUCT_EDIT',
        'PRODUCT_DELETE',
        'PRODUCT_TRANSFER',
        'INVOICE_EDIT',
        'INVOICE_DELETE',
        'INVOICE_TRANSFER',
        'BRAND_SETTINGS',
        'BRAND_REPORTS',
        'BRAND_RECORDS',
        'BRAND_DASHBOARD',
        'BRAND_BUYER',
        'BRAND_TRANSACTIONS',
        'PURCHASE_RATE_VIEW_EDIT',
        'SALE_RATE_VIEW_EDIT',
        'CHANGE_FIN_YEAR',
        'CHANGE_DEFAULT_FIRM',
        'AMOUNT_TRANSFER',
        'BRAND_PRODUCTS',
        'ORDER_RATE_EDIT',
        'INDIVIDUAL_ORDER_EDIT',
        'INDIVIDUAL_ORDER_DELETE',
    ]
export default {
    PERMISSIONS : PERMISSIONS_obj
};


// WEBPACK FOOTER //
// ./src/utils/permissins.js